// Centralized data-testid registry for Meezan Ventures landing page
export const NAV = {
  brand: "nav-brand",
  portfolio: "nav-link-portfolio",
  founder: "nav-link-founder",
  focus: "nav-link-focus",
  contact: "nav-link-contact",
  cta: "nav-cta-contact",
  menuToggle: "nav-menu-toggle",
};

export const HERO = {
  root: "hero-section",
  primaryCta: "hero-cta-portfolio",
  secondaryCta: "hero-cta-founder",
};

export const FOUNDER = {
  root: "founder-section",
  portrait: "founder-portrait",
  linkedin: "founder-linkedin",
};

export const PORTFOLIO = {
  root: "portfolio-section",
  grid: "portfolio-grid",
  card: (slug) => `portfolio-card-${slug}`,
};

export const FOCUS = {
  root: "focus-section",
  card: (slug) => `focus-card-${slug}`,
};

export const PHILOSOPHY = {
  root: "philosophy-section",
};

export const CONTACT = {
  root: "contact-section",
  form: "contact-form",
  inputName: "contact-input-name",
  inputEmail: "contact-input-email",
  inputCompany: "contact-input-company",
  inputMessage: "contact-input-message",
  submit: "contact-submit-button",
  emailLink: "contact-email-link",
  linkedinLink: "contact-linkedin-link",
};

export const FOOTER = {
  root: "footer-section",
};

// Legacy
export const HOME = { emergentLink: "emergent-link" };
